import { API } from './types'
import useAxiosRequest from './useAxiosRequest'
import useOptimisticUpdate from './useOptimisticUpdate'
import { useMutation as useReactQueryMutation } from 'react-query'

const useMutation = (axiosConfig?: API.Config) => {
  const axios = useAxiosRequest(axiosConfig)
  const optimistic = useOptimisticUpdate()

  const mutation = <State, Mutating>(
    params: API.MutationParams<State, Mutating>
  ) => {
    /**
     * If a cacheUpdater method (immer.produce) is passed, the mutation will
     * perform an optimistic update
     */
    const { mutate, ...status } = useReactQueryMutation(
      (data: Mutating) => axios({ ...params, data }),
      optimistic(params)
    )

    return [(data: Mutating) => mutate(data), status] as const
  }

  return mutation
}

export default useMutation
